import { Workbook } from 'exceljs';

import { exportDataGrid } from 'devextreme/excel_exporter';
import saveAs from 'file-saver';

import { ComingNomenclatureFareBalance } from 'bus/comingNomenclatureMain/types';

export const onExporting = (
  refGridMain: any,
  data: ComingNomenclatureFareBalance | null,
  transportName: string,
  date: {
    dateBeginText: string;
    dateEndText: string;
  },
) => {
  const workbook = new Workbook();
  const main = workbook.addWorksheet('Основная информация');

  exportDataGrid({
    component: refGridMain.current?.instance,
    worksheet: main,
    autoFilterEnabled: true,
    topLeftCell: { row: 7, column: 1 },
  })
    .then(() => {
      // header
      const headerRow1 = main.getRow(1);
      const headerRow2 = main.getRow(2);
      const headerRow3 = main.getRow(3);
      const headerRow4 = main.getRow(4);
      const headerRow5 = main.getRow(5);

      main.mergeCells(1, 1, 1, 8);
      main.mergeCells(2, 1, 2, 8);
      main.mergeCells(3, 1, 3, 8);
      main.mergeCells(4, 1, 4, 8);
      main.mergeCells(5, 1, 5, 8);

      headerRow1.getCell(1).value = 'Детализация запчастей';
      headerRow1.getCell(1).font = { bold: true };
      headerRow1.getCell(1).alignment = { horizontal: 'center' };

      headerRow2.getCell(1).value = transportName;
      headerRow2.getCell(1).font = { bold: true };
      headerRow2.getCell(1).alignment = { horizontal: 'center' };

      headerRow3.getCell(1).value = `В период: ${date.dateBeginText} - ${date.dateEndText}`;
      headerRow3.getCell(1).font = { bold: true };
      headerRow3.getCell(1).alignment = { horizontal: 'center' };

      headerRow4.getCell(1).value = `Остаток на начало периода: ${data?.balance}`;
      headerRow4.getCell(1).font = { bold: true };
      headerRow4.getCell(1).alignment = { horizontal: 'left' };

      headerRow5.getCell(1).value = `Остаток на конец периода: ${data?.outBalance}`;
      headerRow5.getCell(1).font = { bold: true };
      headerRow5.getCell(1).alignment = { horizontal: 'left' };
    })
    .then(() => {
      workbook.xlsx.writeBuffer().then((buffer) => {
        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'DataGrid.xlsx');
      });
    });
};
